import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BenchmarkingComponent } from './benchmarking/benchmarking.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { AuthGuard } from './auth-guard/auth.guard';
import { MainComponent } from './main/main.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { IsAdminGuard } from './auth-guard/is-admin.guard';
import { ExternalAnalysisComponent } from './modules/external-analysis/external-analysis.component';

const routes: Routes = [
  { path: '', redirectTo: 'user', pathMatch: "full" },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  },

  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'monitoring', component: MonitoringComponent },
      { path: 'benchmarking', component: BenchmarkingComponent },
      { path:'externalanalysis',component:ExternalAnalysisComponent},
      {
        path: 'performance',
        loadChildren: () => import('./modules/performance/performance.module').then(m => m.PerformanceModule)
      },
      {
        path: 'diagnostic',
        loadChildren: () => import('./modules/diagnostic/diagnostic.module').then(m => m.DiagnosticModule)
      },
      {
        path: 'mobility',
        loadChildren: () => import('./modules/mobility/mobility.module').then(m => m.MobilityModule)
      },
      {
        path: 'wiki',
        loadChildren: () => import('./modules/wiki/wiki.module').then(m => m.WikiModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
      },
      { path: '', redirectTo: 'monitoring', pathMatch: 'full' },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }